import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";

export interface AuthFormCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

/** Card shell used by every auth page (login, forgot/reset password) for consistent layout. */
export function AuthFormCard({ title, subtitle, children, footer }: AuthFormCardProps) {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{ p: { xs: 3, sm: 5 }, width: "100%", maxWidth: 420 }}
    >
      <Stack spacing={3}>
        <Stack spacing={0.5}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
        {children}
        {footer ? <Stack spacing={1}>{footer}</Stack> : null}
      </Stack>
    </Paper>
  );
}
